import FiltersView from './FiltersView'

export default FiltersView
